import { ITableViewConfig, ROWS_PER_PAGE } from '../../shared/models/table-view.model';
import { OBPS_SERVICE, SAVE_PAYMENT , VALIDATE_PAYMENT} from './services/program-management.service';

export const offsetsPaymentsTableConfig: ITableViewConfig = {
  translationPrefix: 'PROGRAM_MANAGEMENT.cra_payments',
  paginator: true,
  rowsPerPage: ROWS_PER_PAGE,
  editService: OBPS_SERVICE + SAVE_PAYMENT,
  validateService: OBPS_SERVICE + VALIDATE_PAYMENT,
  extraHeader: [
    [
      {
        header: 'facility',
        colspan: 7,
      },
      {
        header: 'obligation',
        colspan: 5,
      },
      {
        header: 'intentToPay',
        colspan: 3,
      },
      {
        header: 'section58Report',
        colspan: 2,
      },
      {
        header: 'payment',
        colspan: 4,
      },
      {
        header: 'general',
        colspan: 5,
      },
    ],
  ],
  columns: [
    {
      field: 'accountId',
      header: 'accountId',
      sortField: 'accountId',
      width: '150px',
      editable: false,
      fieldType:'readonly-input',
      inputType:'string',
      newRowField:true,
      editRowField:true,
      required: false
    },{
      field: 'facilityName',
      header: 'facilityName',
      sortField: 'facilityName',
      width: '250px',
      editable: false,
      fieldType:'readonly-input',
      inputType:'string',
      newRowField:true,
      editRowField:true,
      required:false
    },
    {
      field: 'businessNumber',
      header: 'businessNumber',
      sortField: 'businessNumber',
      width: '150px',
      editable: false,
      fieldType:'readonly-input',
      inputType:'string',
      newRowField:true,
      editRowField:true,
      required:false
    },
    {
      field: 'sapCustomerNumber',
      header: 'sapCustomerNumber',
      sortField: 'sapCustomerNumber',
      width: '250px',
      editable: false,
      fieldType:'readonly-input',
      inputType:'string',
      newRowField:false,
      editRowField:false,
      required:false
    },
    {
      field: 'projectProjectId',
      header: 'projectId',
      sortField: 'projectProjectId',
      width: '150px',
      editable: false,
      fieldType:'readonly-input',
      inputType:'string',
      newRowField:true,
      editRowField:true,
      required:false
    },
    {
      field: 'projectName',
      header: 'projectName',
      sortField: 'projectName',
      width: '250px',
      editable: true,
      fieldType:'readonly-input',
      inputType:'string',
      newRowField:true,
      editRowField:true,
      required:true
    },
    {
      field: 'authorizedOfficial',
      header: 'authorizedOfficial',
      sortField: 'authorizedOfficial',
      width: '200px',
      editable: false,
      fieldType:'readonly-input',
      inputType:'string',
      newRowField:true,
      editRowField:true,
      required:false
    },
    {
      field: 'projectReportingPeriod',
      header: 'projectReportingPeriod',
      sortField: 'projectReportingPeriod',
      width: '150px',
      editable: false,
      fieldType:'readonly-input',
      inputType:'string',
      newRowField:true,
      editRowField:true,
      required:false
    },
    {
      field: 'obligationId',
      header: 'compensationObligationId',
      sortField: 'obligationId',
      width: '150px',
      editable: false,
      fieldType:'readonly-input',
      inputType:'string',
      newRowField:true,
      editRowField:true,
      required:false
    },
    {
      field: 'obligationAmountInTonnes',
      header: 'obligationAmountInTonnes',
      sortField: 'obligationAmountInTonnes',
      width: '200px',
      editable: false,
      fieldType:'readonly-input',
      inputType:'string',
      numeric:true,
      newRowField:true,
      editRowField:false
    },
    {
      field: 'obligationAmount',
      header: 'obligationAmount',
      sortField: 'obligationAmount',
      width: '150px',
      editable: false,
      fieldType:'readonly-input',
      inputType:'string',
      numeric:true,
      newRowField:true,
      editRowField:false
    },
     {
      field: 'compensationRate',
      header: 'compensationRate',
      sortField: 'compensationRate',
      width: '150px',
      editable: false,
      fieldType:'readonly-input',
      inputType:'string',
      newRowField:true,
      editRowField:false
    },
    {
      field: 'itpRefNumber',
      header: 'itpRefNum',
      sortField: 'itpRefNumber',
      width: '150px',
      editable: false,
      fieldType:'readonly-input',
      inputType:'string',
      newRowField:true,
      editRowField:true
    },
    {
      field: 'intendedPaymentAmount',
      header: 'intendedPaymentAmount',
      sortField: 'intendedPaymentAmount',
      width: '200px',
      editable: false,
      fieldType:'readonly-input',
      inputType:'number',
      newRowField:true,
      editRowField:false,
      numeric: true
    },
    {
      field: 'intendedPaymentDateStr',
      header: 'intendedPaymentDate',
      sortField: 'intendedPaymentDate',
      width: '150px',
      editable: false,
      fieldType:'readonly-input',
      inputType:'string',
      newRowField:true,
      editRowField:true,
      formField: 'intendedPaymentDate'
    },
     {
      field: 'paymentAmount',
      header: 'wireTransferPaymentAmountCAD',
      sortField: 'paymentAmount',
      width: '200px',
      editable: false,
      fieldType:'readonly-input',
      inputType:'formatted-number',
      newRowField:true,
      editRowField:true,
      numeric: true
    },
    {
      field: 'paymentDateStr',
      header: 'wireTransferDate',
      sortField: 'paymentDate',
      width: '150px',
      editable: false,
      fieldType:'readonly-input',
      inputType:'string',
      newRowField:true,
      editRowField:true,
      formField: 'paymentDateStr'
    },
    {
      field: 'paymentReceived',
      header: 'paymentReceivedCAD',
      sortField: 'paymentReceived',
      width: '150px',
      editable: false,
      fieldType:'input',
      inputType:'number',
      invalidMessage:'paymentMustBePositiveNumber',
      newRowField:true,
      editRowField:true,
      numeric: true
    },
    {
      field: 'craPaymentItemId',
      header: 'paymentId',
      sortField: 'craPaymentItemId',
      width: '150px',
      editable: false,
      fieldType:'input',
      inputType:'string',
      newRowField:true,
      editRowField:true,
      required:false
    },
    {
      field: 'documentDateStr',
      header: 'documentDate',
      sortField: 'documentDate',
      width: '150px',
      editable: false,
      fieldType:'app-formly-datepicker',
      inputType:'string',
      newRowField:true,
      editRowField:true,
      formField: 'documentDate'
    },
    {
      field: 'sapPostingDateStr',
      header: 'sapPostingDate',
      sortField: 'sapPostingDate',
      width: '150px',
      editable: false,
      fieldType:'app-formly-datepicker',
      inputType:'string',
      newRowField:true,
      editRowField:true,
      formField: 'sapPostingDate'
    },
    {
      field: 'actionPerformedBy',
      header: 'actionInitiatedBy',
      sortField: 'actionPerformedBy',
      width: '150px',
      editable: false,
      fieldType:'input',
      inputType:'string',
      newRowField:true,
      editRowField:false,
      required:false
    },
    {
      field: 'lastActionPerformedBy',
      header: 'lastActionPerformedBy',
      sortField: 'lastActionPerformedBy',
      width: '150px',
      editable: false,
      fieldType:'input',
      inputType:'string',
      newRowField:true,
      editRowField:false,
      required:false
    },
    {
      field: 'comments',
      header: 'comments',
      sortField: 'comments',
      width: '150px',
      editable: false,
      fieldType:'input',
      inputType:'string',
      newRowField:true,
      editRowField:false,
      required:false
    },
    {
      field: 'status',
      header: 'status',
      sortField: 'status',
      translate:true,
      translationPrefix:'COMMON.statusList',
      width: '150px',
      editable: false
    },
  ],
};

export const craPaymentsTableConfig: ITableViewConfig = {
  translationPrefix: 'PROGRAM_MANAGEMENT.cra_payments',
  paginator: true,
  rowsPerPage: ROWS_PER_PAGE,
  editService: OBPS_SERVICE + SAVE_PAYMENT,
  validateService: OBPS_SERVICE + VALIDATE_PAYMENT,
  width: 2000,
  extraHeader: [
    [
      {
        header: 'facility',
        colspan: 5,
      },
      {
        header: 'obligation',
        colspan: 5,
      },
      {
        header: 'intentToPay',
        colspan: 3,
      },
      {
        header: 'section58Report',
        colspan: 2,
      },
      {
        header: 'payment',
        colspan: 4,
      },
      {
        header: 'general',
        colspan: 5,
      },
    ],
  ],
  columns: [
    {
      field: 'facilityCertificateNumber',
      header: 'facilityCertificate',
      sortField: 'facilityCertificateNumber',
      width: '200px',
      editable: false,
      fieldType:'readonly-input',
      inputType:'string',
      newRowField:true,
      editRowField:true,
      required: false
    },{
      field: 'facilityName',
      header: 'facilityName',
      sortField: 'facilityName',
      width: '200px',
      editable: false,
      fieldType:'readonly-input',
      inputType:'string',
      newRowField:true,
      editRowField:true,
      required:false
    },
    {
      field: 'businessNumber',
      header: 'businessNumber',
      sortField: 'businessNumber',
      width: '200px',
      editable: false,
      fieldType:'readonly-input',
      inputType:'string',
      newRowField:true,
      editRowField:true,
      required:false
    },
    {
      field: 'sapCustomerNumber',
      header: 'sapCustomerNumber',
      sortField: 'sapCustomerNumber',
      width: '200px',
      editable: false,
      fieldType:'readonly-input',
      inputType:'string',
      newRowField:false,
      editRowField:false,
      required:false
    },
    {
      field: 'responsiblePersons',
      header: 'responsiblePersons',
      sortField: 'responsiblePersons',
      width: '200px',
      editable: false,
      fieldType:'readonly-input',
      inputType:'string',
      newRowField:false,
      editRowField:false,
      required:false
    },
    {
      field: 'complianceYear',
      header: 'complaincePeriod',
      sortField: 'complianceYear',
      width: '200px',
      editable: false,
      fieldType:'readonly-input',
      inputType:'string',
      newRowField:true,
      editRowField:true,
      required:false
    },
    {
      field: 'obligationId',
      header: 'obligationId',
      sortField: 'obligationId',
      width: '200px',
      editable: false,
      fieldType:'readonly-input',
      inputType:'string',
      newRowField:true,
      editRowField:true,
      required:false
    },
    {
      field: 'obligationAmountInTonnes',
      header: 'obligationAmountInTonnes',
      sortField: 'obligationAmountInTonnes',
      width: '200px',
      editable: false,
      fieldType:'readonly-input',
      inputType:'string',
      numeric:true,
      newRowField:true,
      editRowField:false
    },
    {
      field: 'obligationAmount',
      header: 'obligationAmount',
      sortField: 'obligationAmount',
      width: '200px',
      editable: false,
      fieldType:'readonly-input',
      inputType:'string',
      numeric:true,
      newRowField:true,
      editRowField:false
    },
     {
      field: 'compensationRate',
      header: 'compensationRate',
      sortField: 'compensationRate',
      width: '200px',
      editable: false,
      fieldType:'readonly-input',
      inputType:'string',
      newRowField:true,
      editRowField:false
    },
    {
      field: 'itpRefNumber',
      header: 'itpRefNum',
      sortField: 'itpRefNumber',
      width: '200px',
      editable: false,
      fieldType:'readonly-input',
      inputType:'string',
      newRowField:true,
      editRowField:true
    },
    {
      field: 'intendedPaymentAmount',
      header: 'intendedPaymentAmount',
      sortField: 'intendedPaymentAmount',
      width: '200px',
      editable: false,
      fieldType:'readonly-input',
      inputType:'number',
      newRowField:true,
      editRowField:false,
      numeric: true
    },
    {
      field: 'intendedPaymentDateStr',
      header: 'intendedPaymentDate',
      sortField: 'intendedPaymentDate',
      width: '200px',
      editable: false,
      fieldType:'readonly-input',
      inputType:'string',
      newRowField:true,
      editRowField:true,
      formField: 'intendedPaymentDate'
    },
     {
      field: 'paymentAmount',
      header: 'wireTransferPaymentAmountCAD',
      sortField: 'paymentAmount',
      width: '200px',
      editable: false,
      fieldType:'readonly-input',
      inputType:'formatted-number',
      newRowField:true,
      editRowField:true,
      numeric: true
    },
    {
      field: 'paymentDateStr',
      header: 'wireTransferDate',
      sortField: 'paymentDate',
      width: '200px',
      editable: false,
      fieldType:'readonly-input',
      inputType:'string',
      newRowField:true,
      editRowField:true,
      formField: 'paymentDateStr'
    },
    {
      field: 'paymentReceived',
      header: 'paymentReceivedCAD',
      sortField: 'paymentReceived',
      width: '200px',
      editable: false,
      fieldType:'input',
      inputType:'number',
      invalidMessage:'paymentMustBePositiveNumber',
      newRowField:true,
      editRowField:true,
      numeric: true
    },
    {
      field: 'craPaymentItemId',
      header: 'paymentId',
      sortField: 'craPaymentItemId',
      width: '200px',
      editable: false,
      fieldType:'input',
      inputType:'string',
      newRowField:true,
      editRowField:true,
      required:false
    },
    {
      field: 'documentDateStr',
      header: 'documentDate',
      sortField: 'documentDate',
      width: '200px',
      editable: false,
      fieldType:'app-formly-datepicker',
      inputType:'string',
      newRowField:true,
      editRowField:true,
      formField: 'documentDate'
    },
    {
      field: 'sapPostingDateStr',
      header: 'sapPostingDate',
      sortField: 'sapPostingDate',
      width: '200px',
      editable: false,
      fieldType:'app-formly-datepicker',
      inputType:'string',
      newRowField:true,
      editRowField:true,
      formField: 'sapPostingDate'
    },
    {
      field: 'actionPerformedBy',
      header: 'actionInitiatedBy',
      sortField: 'actionPerformedBy',
      width: '200px',
      editable: false,
      fieldType:'input',
      inputType:'string',
      newRowField:true,
      editRowField:false,
      required:false
    },
    {
      field: 'lastActionPerformedBy',
      header: 'lastActionPerformedBy',
      sortField: 'lastActionPerformedBy',
      width: '200px',
      editable: false,
      fieldType:'input',
      inputType:'string',
      newRowField:true,
      editRowField:false,
      required:false
    },
    {
      field: 'comments',
      header: 'comments',
      sortField: 'comments',
      width: '200px',
      editable: false,
      fieldType:'input',
      inputType:'string',
      newRowField:true,
      editRowField:false,
      required:false
    },
    {
      field: 'status',
      header: 'status',
      sortField: 'status',
      translate:true,
      translationPrefix:'COMMON.statusList',
      width: '200px',
      editable: false
    },
  ],
};


export const craNotesConfig: ITableViewConfig = {
  translationPrefix: 'COMMON.custom_messages',
  paginator: true,
  rowsPerPage: ROWS_PER_PAGE,
  editService:'/obps-service/transaction/notes',
  columns: [
    {
      field: 'id',
      header: 'id',
      sortField: 'id',
      width: '200px',
      editable: false,
      fieldType:'readonly-input',
      inputType:'number',
      editRowField:false
    },{
      field: 'notes',
      header: 'notes',
      sortField: 'respond',
      width: '200px',
      editable: false,
      fieldType:'textarea',
      inputType:'string',
      editRowField:true,
      className:'col-12'
    }
  ],
};

